import { apiV1Endpoint } from "../../../../../api/v1";
import axios from "../../../../../utils/axiosInceptor";

export type AddCommentRequest = {
  comment: string;
  type: string;
  moduleId: string;
};

export const addCommentRequest = async (body: AddCommentRequest) => {
  const url = `${apiV1Endpoint}/maintenance/ticket/comment`;
  const response = await axios.post(url, body);
  return response.data;
};
